export interface ProductWizard {
    id: string /** Id del servicio */;
    familyId: string /** Id de la familia del servicio */;
    familySourceId: string /** SourceId de la familia del servicio */;
    clinicName: string /** Nombre de la clínica donde está este producto */;
    description: string /** Nombre del servicio */;
    type: string /** TODO: Que es */;
    price: string /** Precio del servicio */;
    promotedPrice: string /** Preciocon descuento, si viene a 0 es porque no tiene precio con descuento */;
    points: string /** TODO: Que es */;
    currencyFormat: string /** Información de formato de la moneda del producto */;
    currencySymbol: string /** Información del simbolo de la moneda del producto */;
    currencySymbolPosition: string /** Información de la posición de la moneda del producto sobre el precio */;
    unitsCart: number /** Unidades seleccionadas para la compra */;
    checked: boolean /** Indica si el usuario a seleccionado este servicio (lógica interna del asistente) */;
}

export interface ProductWizardCheckedEvent {
    product: ProductWizard;
    newUnits: number;
}

/**
 * A factory function that creates ProductWizard
 */
export function createProductWizard(params: Partial<ProductWizard>) {
    return {} as ProductWizard;
}

/**
 * Factoría que crea un Servicio para el asistente de pedir cita con los datos recogidos por la API
 */
export function productWizardFactory(params: any) {
    return {
        id: params.ProductId,
        familyId: params.ProductFamilyId,
        familySourceId: params.ProductFamilySourceId,
        clinicName: params.ProductClinicName,
        description: params.ProductDesc,
        type: params.ProductType,
        price: params.ProductPrice,
        promotedPrice:
            params.ProductPromotedPrice === '0'
                ? ''
                : params.ProductPromotedPrice === '-1'
                ? '0'
                : params.ProductPromotedPrice,
        points: params.ProductPoints ?? null,
        currencyFormat: params.CurrencyFormat,
        currencySymbol: params.CurrencySymbol,
        currencySymbolPosition: params.CurrencySymbolPosition,
        unitsCart: 0,
        checked: false,
    } as ProductWizard;
}
